import { useDeleteExercisePreset } from '#api/exercise-presets';
import { queryKeyFactory } from '#api/queryKeyFactory';
import { More } from '#assets/svg';
import { useToast } from '#providers/ToastProvider';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { Tooltip } from 'src/shared/components/tooltip/Tooltip';
import { ChangePresetsBottomSheet } from './change-presets/ChangePresets';

interface PresetChangeProps {
  id: string;
}
export const PresetChange = ({ id }: PresetChangeProps) => {
  const [openBottomSheet, setOpenBottomSheet] = useState<boolean>(false);

  return (
    <>
      <Tooltip tooltipTrigger={<More />} position="bottom-right">
        <TooltipContent
          id={id}
          setOpenBottomSheet={value => setOpenBottomSheet(value)}
        />
      </Tooltip>

      {openBottomSheet && (
        <ChangePresetsBottomSheet
          id={id}
          openBottomSheet={openBottomSheet}
          setOpenBottomSheet={setOpenBottomSheet}
        />
      )}
    </>
  );
};
interface TooltipContentProps {
  id: string;
  setOpenBottomSheet: (value: boolean) => void;
}
const TooltipContent = ({ id, setOpenBottomSheet }: TooltipContentProps) => {
  const { showToast } = useToast();

  const queryClient = useQueryClient();

  const { mutate } = useDeleteExercisePreset({
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeyFactory.GET_EXERCISE_PRESETS());
      showToast({
        type: 'success',
        message: '프리셋이 삭제되었습니다.'
      });
    },
    onError: () => {
      showToast({
        type: 'fail',
        message: '프리셋 추가에 실패했습니다.'
      });
    }
  });

  const onClickEdit = () => {
    setOpenBottomSheet(true);
  };

  const onClickDelete = () => {
    mutate(id);
  };

  return (
    <>
      <div className="w-160 h-108 px-12 py-16  rounded-xl flex-col justify-center inline-flex">
        <div
          onClick={onClickEdit}
          className="pb-16 text-[#bcb8c3] text-[17px] font-medium font-['Pretendard Variable' border-b-1 border-solid border-[#2e2a3a]"
        >
          수정
        </div>
        <div
          onClick={onClickDelete}
          className="pt-16 text-[#e13a3a] text-[17px] font-medium font-['Pretendard Variable']"
        >
          삭제
        </div>
      </div>
    </>
  );
};
